module.exports = __webpack_public_path__ + "img/check-list.1c3d26f4.svg";